import { Component, Input, OnInit } from '@angular/core';
import { IDeposit } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'product-deposit-section',
  templateUrl: './product-deposit-section.component.html',
  styleUrls: ['./product-deposit-section.component.scss']
})
export class ProductDepositSectionComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() deposit: IDeposit;
  @Input() currency: string = '';

  constructor() {
  }

  ngOnInit() {
  }
}
